import { render } from "./FormatMoney.vue?vue&type=template&id=73bdd95b"
import script from "./FormatMoney.vue?vue&type=script&lang=js"
export * from "./FormatMoney.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__